
























































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import AsignacionNoSeriado from '@/pantallas/Conecta/SolicitudStock/AsignacionNoSeriado.vue';
import AsignacionSeriado from '@/pantallas/Conecta/SolicitudStock/AsignacionSeriado.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import NavegacionModalCrud from '@/reusable/Mantenedor/NavegacionModalCrud.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import ModalRequerimiento from './ModalRequerimiento.vue';
import { utils, writeFileXLSX } from 'xlsx';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    NavegacionModalCrud,
    FormFieldsContainer,
    DatePicker,
    AsignacionNoSeriado,
    AsignacionSeriado,
    ModalRequerimiento,
  },
})
export default class ModalAsignacion extends Vue {
  @Prop({ default: false }) show: boolean;
  @Prop({
    required: true,
    default: {
      asignumero: '',
      modalidad: '',
      estado: '',
      modalidadid: '',
      asigcreacion_auto: '',
      asigdeta_finalizado: '',
    },
  })
  registroSeleccionado: any;
  @Prop({ required: true, default: null }) data: any;
  /* misc */
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  dataEvidencia: any = [];
  dataEvidenciaResumen: any = [];
  dataReservas: any = [];
  dataReservasResumen: any = [];

  dialogConfirmacionGuardar: boolean = false;
  // tituloCabecera: any =
  //   'Detalle Asignación ' + this.registroSeleccionado.asigrequerimiento;
  testt: string = 'test';
  /* event handlers */

  pasoActivoIndex = 1;
  pasos = {
    informacionGeneral: {
      accion: 'Crear - Información General',
      visible: true,
      step: 1,
    },
  };
  listaClientes: any[] = [];
  listaFlotas: any[] = [];
  tabs: any = null;

  showInfo: boolean = true;

  get fechaMaxima() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    let fechaMax = yyyy + '-' + mm + '-' + dd;
    return fechaMax;
  }

  created() {}

  mounted() {}

  handleCerrar() {
    this.$emit('cerrar');
  }

  updateValueEvidencia(dataEvidencia: any) {
    this.dataEvidencia = dataEvidencia;
  }
  updateValueEvidenciaResumen(dataEvidenciaResumen: any) {
    this.dataEvidenciaResumen = dataEvidenciaResumen;
  }
  updateValueReserva(dataReservas: any) {
    this.dataReservas = dataReservas;
  }
  updateValueReservaResumen(dataReservasResumen: any) {
    this.dataReservasResumen = dataReservasResumen;
  }
  downloadExcel() {
    //console.log(this.dataEvidencia);
    //console.log(this.dataEvidenciaResumen);
    //console.log(this.dataReservas);
    //console.log(this.dataReservasResumen);

    this.loadingService.showLoading(undefined, 'download_template_serie');
    let headers = {};
    headers = { header: ['Serie'] };

    let ws: any = null;
    let name: string = '';
    const wb = utils.book_new();

    //hoja evidencia
    let headersEvidencia = {
      header: [
        'Equipo',
        'Serie',
        'Plataforma',
        'Técnico',
        'Región',
        'Ciudad',
        'Estatus',
        'Stock',
        'CAS-NDV Asignado',
        'Observación',
        'Salida',
        'RUT',
        'OK',
      ],
    };
    let dataEvidenciaOrdenada = this.dataEvidencia.map((v: any) => {
      return {
        Equipo: v.equipo,
        Serie: v.serie,
        Plataforma: v.plataforma,
        Técnico: v.tecnico,
        Región: v.region,
        Ciudad: v.ciudad,
        Estatus: v.estatus,
        Stock: v.stock,
        'CAS-NDV Asignado': v.cas_ndv_asignado,
        Observación: v.observacion,
        Salida: v.salida,
        RUT: v.rut,
        OK: v.ok,
      };
    });
    ws = utils.json_to_sheet(dataEvidenciaOrdenada, headersEvidencia);
    utils.book_append_sheet(wb, ws, 'Evidencia Series');

    //hoja resumen evidencia
    let headersEvidenciaResumen = { header: ['Equipo', 'Total'] };
    let dataEvidenciaResumenOrdenada = this.dataEvidenciaResumen.map(
      (v: any) => {
        return {
          Equipo: v.equipo,
          Total: v.total,
        };
      }
    );
    ws = utils.json_to_sheet(
      dataEvidenciaResumenOrdenada,
      headersEvidenciaResumen
    );
    utils.book_append_sheet(wb, ws, 'Evidencia Series Resumen');

    //hoja series reservadas
    let headersReservas = { header: ['Serie', 'Equipo'] };
    let dataReservasOrdenada = this.dataReservas.map((v: any) => {
      return {
        Serie: v.serienumero,
        Equipo: v.tipoeq,
      };
    });
    ws = utils.json_to_sheet(dataReservasOrdenada, headersReservas);
    utils.book_append_sheet(wb, ws, 'Series Reservadas');

    //hoja resumen evidencia
    let headersReservasResumen = { header: ['Equipo', 'Total'] };
    let dataReservasResumenOrdenada = this.dataReservasResumen.map((v: any) => {
      return {
        Equipo: v.equipo,
        Total: v.total,
      };
    });
    ws = utils.json_to_sheet(
      dataReservasResumenOrdenada,
      headersReservasResumen
    );
    utils.book_append_sheet(wb, ws, 'Series Reservadas Resumen');

    writeFileXLSX(
      wb,
      `Plantilla_Preparacion_EQ_${this.registroSeleccionado.asignumero}_${name}.xlsx`
    );
    this.$snotify.success('Plantilla Excel descargada con éxito');
    this.loadingService.hideLoading('download_template_serie');
  }

  finalizarReq() {
    this.$emit('FinalizarClick', { data: this.data });
  }

  handleInfoGeneral() {
    this.showInfo = true;
  }
  updateGrilla() {
    //console.log('updateGrilla');
    (this.$refs
      .AsignacionNoSeriadoComponent as any).get_detalle_archivo_stock();
  }
}
